import React from "react";
import NavbarOne from "./separate/NavbarOne";
import Footer from "./separate/Footer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import "../assets/style.css";
import PageTitleDes from "../core/support/PageTitleDes";

export default function AboutUs(props) {
  const navigate = useNavigate();

  return (
    <div className="about-page bg-default text-white">
      <PageTitleDes title={`About Us | Trusted Cryptocurrency Exchange Platform`} description={`Learn about our mission to make cryptocurrency trading simple, secure, and accessible. Discover our vision, team, and commitment to innovation.`} />
      <NavbarOne setTheme={props.setTheme} theme={props.theme} />

      <div className="container py-5">

        <div className="d-flex align-items-center mb-2">
          <div className="aboutUs-back-btn" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </div>
          <h4 className="ms-3 fw-bold mb-0">About Us</h4>
        </div>

        <div className="about-hero text-center">
          <div className="aboutUs-logo-wrapper mx-auto mb-3">
            <img src="/logo192.png" alt="Uniticexchange" />
          </div>

          <h1 className="aboutUs-hero-title">
            Welcome to Uniticexchange
          </h1>

          <p className="aboutUs-hero-subtitle">
            Your Gateway to the World of Crypto
          </p>
        </div>

        <div className="about-card mt-4">
          <p>
            Uniticexchange is a pioneering Web3 firm that stands at the forefront of revolutionizing the crypto landscape. Our central ethos revolves around providing a seamless and secure platform for trading various cryptocurrencies and fiat pairs, including INR. We pride ourselves on offering top-tier services tailored for a hassle-free and enriching user experience.
          </p>

          <p>
            At Uniticexchange, we understand the importance of a smooth journey into the world of digital assets. With a multitude of crypto pairs and fiat options like INR, we facilitate diverse and flexible trading opportunities, empowering users to explore and engage in the thriving crypto market effortlessly.
          </p>

          <p>
            Our commitment to transparency and adherence to Know Your Customer (KYC) norms underline our dedication to maintaining a trustworthy and compliant ecosystem. We prioritize the safety and security of our users' funds and information, ensuring stringent measures are in place at every step.
          </p>

          <p>
            We prioritize your convenience, offering a meticulously designed platform that streamlines INR deposits and withdrawals. Our meticulous approach to these processes reflects our dedication to providing a secure and reliable trading environment.
          </p>

          <p>
            Uniticexchange is more than just a crypto exchange; it's a community-driven platform committed to fostering financial inclusivity and innovation. Whether you're a seasoned trader or a newcomer to the crypto space, our platform caters to your needs with user-friendly interfaces, robust security protocols, and responsive customer support.
          </p>

          <p className="aboutUs-highlight-text">
            Join us on this transformative journey into the future of finance.
          </p>

          <p className="aboutUs-highlight-text">
            Discover the power of crypto trading with Uniticexchange — Where Every Transaction is a Testament to Trust and Excellence.
          </p>
        </div>

        {/* Features Section */}
        <div className="row mt-3 g-4 text-center">
          <div className="col-md-4">
            <div className="aboutUs-feature-box">
              <h5>Secure Platform</h5>
              <p>Advanced security protocols to safeguard your assets.</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="aboutUs-feature-box">
              <h5>Fast Transactions</h5>
              <p>Instant deposits and withdrawals with INR support.</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="aboutUs-feature-box">
              <h5>User Friendly</h5>
              <p>Simple, clean, and powerful trading experience.</p>
            </div>
          </div>
        </div>

      </div>

      <Footer />
    </div>
  );
}